import { API } from "@/main.js";
import { reject } from "lodash";

const state = {
  modulesStates: []
};

const getters = {
  modulesStates: state => state.modulesStates
};

const mutations = {
  setModulesStates(state, modulesStates) {
    state.modulesStates = modulesStates;
  }
};

const actions = {
  fetchModulesStates({ commit }) {
    return new Promise((resolve, reject) => {
      API.modules.getModulesStates(
        resp => {
          let data = resp.data.data;

          commit("setModulesStates", data);

          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  editModulesStates({ commit }, { data }) {
    return new Promise((resolve, reject) => {
      API.modules.editModulesStates(
        data,
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/modules.js